import * as ActionTypes from '../actionTypes';

export const receivePart = (state = {}, action) => {
	switch (action.type) {
		case ActionTypes.UPDATE_RECEIVE_PART:
			return {
				...state,
				serialNumber: action.serialNumber,
			};
		default:
			return state;
	}
};
